// Generated by purs version 0.15.15
import * as $foreign from "./foreign.js";
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_EuclideanRing from "../Data.EuclideanRing/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Int from "../Data.Int/index.js";
import * as Data_List_Types from "../Data.List.Types/index.js";
import * as Data_Map_Internal from "../Data.Map.Internal/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Nullable from "../Data.Nullable/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Pitches_Class from "../Data.Pitches.Class/index.js";
import * as Data_Pitches_Spelled from "../Data.Pitches.Spelled/index.js";
import * as Data_Ratio from "../Data.Ratio/index.js";
import * as Data_Set from "../Data.Set/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as ProtoVoices_JSONTransport from "../ProtoVoices.JSONTransport/index.js";
import * as ProtoVoices_Model from "../ProtoVoices.Model/index.js";
var map = /* #__PURE__ */ Data_Functor.map(Data_Functor.functorArray);
var fromFoldable = /* #__PURE__ */ Data_Array.fromFoldable(Data_Set.foldableSet);
var show = /* #__PURE__ */ Data_Show.show(ProtoVoices_Model.showRightOrnament);
var show1 = /* #__PURE__ */ Data_Show.show(ProtoVoices_Model.showLeftOrnament);
var show2 = /* #__PURE__ */ Data_Show.show(ProtoVoices_Model.showDoubleOrnament);
var spelledPitch = /* #__PURE__ */ Data_Pitches_Spelled.spelledPitch(Data_Pitches_Spelled.spelledSInterval)(Data_Pitches_Spelled.hasIntervalClassSInterval)(Data_Pitches_Spelled.spelledSIC);
var letter = /* #__PURE__ */ Data_Pitches_Spelled.letter(spelledPitch);
var octaves = /* #__PURE__ */ Data_Pitches_Spelled.octaves(spelledPitch);
var alteration = /* #__PURE__ */ Data_Pitches_Spelled.alteration(spelledPitch);
var sortWith = /* #__PURE__ */ Data_Array.sortWith(/* #__PURE__ */ Data_Pitches_Class.ordPitch(Data_Pitches_Spelled.ordSInterval));
var eq = /* #__PURE__ */ Data_Eq.eq(/* #__PURE__ */ Data_Ratio.eqRatio(Data_Eq.eqInt));
var reduce = /* #__PURE__ */ Data_Ratio.reduce(Data_Ord.ordInt)(Data_EuclideanRing.euclideanRingInt);
var show3 = /* #__PURE__ */ Data_Show.show(Data_Show.showInt);
var fromFoldable1 = /* #__PURE__ */ Data_Array.fromFoldable(Data_List_Types.foldableList);
var map1 = /* #__PURE__ */ Data_Functor.map(Data_List_Types.functorList);
var map2 = /* #__PURE__ */ Data_Functor.map(Data_Maybe.functorMaybe);
var mkRenderTrans = function (t) {
    var innerEdges = function (edges) {
        return Data_Array.catMaybes(map(function (edge) {
            if (edge.left instanceof ProtoVoices_Model.Inner && edge.right instanceof ProtoVoices_Model.Inner) {
                return new Data_Maybe.Just({
                    left: edge.left.value0,
                    right: edge.right.value0
                });
            };
            return Data_Maybe.Nothing.value;
        })(edges));
    };
    return {
        regular: innerEdges(fromFoldable(t.edges.regular)),
        passing: innerEdges(t.edges.passing),
        id: t.id
    };
};
var encodeExplanation = function (expl) {
    if (expl instanceof ProtoVoices_Model.NoExpl) {
        return {
            typ: "None",
            parent: Data_Nullable["null"]
        };
    };
    if (expl instanceof ProtoVoices_Model.RootExpl) {
        return {
            typ: "Root",
            parent: Data_Nullable["null"]
        };
    };
    if (expl instanceof ProtoVoices_Model.HoriExpl) {
        return {
            typ: "Hori",
            parent: Data_Nullable.notNull(expl.value0.id)
        };
    };
    if (expl instanceof ProtoVoices_Model.RightExpl) {
        return {
            typ: (function () {
                if (expl.value0.orn instanceof Data_Maybe.Nothing) {
                    return "RightNone";
                };
                if (expl.value0.orn instanceof Data_Maybe.Just) {
                    return show(expl.value0.orn.value0);
                };
                throw new Error("Failed pattern match at ProtoVoices.RenderSVG (line 165, column 12 - line 167, column 25): " + [ expl.value0.orn.constructor.name ]);
            })(),
            parent: Data_Nullable["null"]
        };
    };
    if (expl instanceof ProtoVoices_Model.LeftExpl) {
        return {
            typ: (function () {
                if (expl.value0.orn instanceof Data_Maybe.Nothing) {
                    return "LeftNone";
                };
                if (expl.value0.orn instanceof Data_Maybe.Just) {
                    return show1(expl.value0.orn.value0);
                };
                throw new Error("Failed pattern match at ProtoVoices.RenderSVG (line 171, column 12 - line 173, column 25): " + [ expl.value0.orn.constructor.name ]);
            })(),
            parent: Data_Nullable["null"]
        };
    };
    if (expl instanceof ProtoVoices_Model.DoubleExpl) {
        return {
            typ: (function () {
                if (expl.value0.orn instanceof Data_Maybe.Nothing) {
                    return "DoubleNone";
                };
                if (expl.value0.orn instanceof Data_Maybe.Just) {
                    return show2(expl.value0.orn.value0);
                };
                throw new Error("Failed pattern match at ProtoVoices.RenderSVG (line 177, column 12 - line 179, column 25): " + [ expl.value0.orn.constructor.name ]);
            })(),
            parent: Data_Nullable["null"]
        };
    };
    throw new Error("Failed pattern match at ProtoVoices.RenderSVG (line 160, column 26 - line 181, column 6): " + [ expl.constructor.name ]);
};
var mkRenderSlice = function (toX) {
    return function (slice) {
        var noteToVex = function (n) {
            return {
                id: n.note.id,
                name: letter(n.note.pitch),
                oct: octaves(n.note.pitch),
                accs: alteration(n.note.pitch),
                sel: n,
                expl: encodeExplanation(n.expl)
            };
        };
        return {
            x: toX(slice.x),
            id: slice.id,
            notes: map(noteToVex)(sortWith(function (v) {
                return v.note.pitch;
            })(ProtoVoices_Model.getInnerNotes(slice)))
        };
    };
};
var renderGraph = function (graph) {
    return function (piece) {
        return function (surface) {
            return function (styles) {
                return function (selection) {
                    return function (selectCallback) {
                        return function (toX) {
                            var mkTime = function (i) {
                                return function (time) {
                                    var label = (function () {
                                        if (time instanceof Data_Either.Right) {
                                            var $47 = eq(time.value0.s)(reduce(0)(1));
                                            if ($47) {
                                                return show3(time.value0.m) + ("." + show3(time.value0.b));
                                            };
                                            return "";
                                        };
                                        if (time instanceof Data_Either.Left) {
                                            return time.value0;
                                        };
                                        throw new Error("Failed pattern match at ProtoVoices.RenderSVG (line 126, column 13 - line 128, column 22): " + [ time.constructor.name ]);
                                    })();
                                    return {
                                        x: toX(Data_Int.toNumber(i + 1 | 0)),
                                        label: label
                                    };
                                };
                            };
                            var mkGraphSlice = function (s) {
                                var rs = mkRenderSlice(toX)(s.slice);
                                return {
                                    depth: s.depth,
                                    x: rs.x,
                                    id: rs.id,
                                    notes: rs.notes
                                };
                            };
                            return $foreign.drawGraph({
                                slices: fromFoldable1(map1(mkGraphSlice)(Data_Map_Internal.values(graph.slices))),
                                surfaceSlices: map(mkRenderSlice(toX))(surface.slices),
                                transitions: fromFoldable1(map1(mkRenderTrans)(Data_Map_Internal.values(graph.transitions))),
                                surfaceTransitions: map(mkRenderTrans)(surface.transs),
                                horis: fromFoldable1(graph.horis),
                                times: Data_Array.mapWithIndex(mkTime)(map(function (v) {
                                    return v.time;
                                })(piece)),
                                maxd: graph.maxd,
                                selection: (function () {
                                    if (selection instanceof Data_Maybe.Nothing) {
                                        return Data_Nullable["null"];
                                    };
                                    if (selection instanceof Data_Maybe.Just) {
                                        return Data_Nullable.notNull({
                                            note: selection.value0.note,
                                            parents: ProtoVoices_Model.explParents(selection.value0.expl)
                                        });
                                    };
                                    throw new Error("Failed pattern match at ProtoVoices.RenderSVG (line 107, column 16 - line 109, column 75): " + [ selection.constructor.name ]);
                                })(),
                                select: Data_Nullable.toNullable(map2(function (v) {
                                    return function ($57) {
                                        return v(Data_Nullable.toMaybe($57));
                                    };
                                })(selectCallback)),
                                styles: ProtoVoices_JSONTransport.stylesToJSON(styles)
                            });
                        };
                    };
                };
            };
        };
    };
};
var renderScore = function (slices) {
    return function (transitions) {
        return function (toX) {
            return function (staffType) {
                return $foreign.drawScore(map(mkRenderSlice(toX))(slices))(map(mkRenderTrans)(transitions))(ProtoVoices_Model.staffType2JS(staffType));
            };
        };
    };
};
export {
    defaultStyles,
    drawScore,
    insertScore,
    drawGraph
} from "./foreign.js";
export {
    renderScore,
    renderGraph,
    mkRenderSlice,
    mkRenderTrans,
    encodeExplanation
};
